export default "__VITE_ASSET__Dhcml5fS__"